module.exports = __webpack_public_path__ + "img/ico_new_order.e9f55c12.svg";